// ─── Authentication Endpoints ─────────────────────────────────────────────────

export const API_LOGIN = '/admin/adminLogin';
export const API_SHARE_LOCATION = '/trip/tripdetails/';
